import React, { useState, useEffect } from "react";
import { FiEye, FiTrash2 } from "react-icons/fi";

import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_candidates_list,
  admin_cand_delete,
  admin_candidates_employed_list,
  admin_candidates_inactive_list,
  admin_candidates_deactivated_list,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import * as XLSX from "xlsx";

const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "0", label: "Pending" },
  { value: "1", label: "Submitted" },
  { value: "2", label: "Approved" },
  { value: "3", label: "Reverted to user" },
  { value: "4", label: "Reverted to admin" },
  { value: "5", label: "Rejected" },
  { value: "9", label: "Deactivated" },
];

const getStatusInfo = (status, id) => {
  if (id === "employed") {
    const statusMap = {
      0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
      1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
      2: { label: "Approved", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
      3: { label: "Joined Successfully", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
      4: { label: "Payment Done", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
      5: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    };
    return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
  }
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Approved", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "Reverted to user", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    4: { label: "Reverted to admin", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    5: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    9: { label: "Deactivated", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function View(props) {
  const [data, setdata] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  // Filter state
  const [status, setStatus] = useState("");
  const [showFilters, setShowFilters] = useState(true);

  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const { id } = useParams();

  const handleListData = () => {
    setIsActive(true);
    const pg = page;
    const pp = perPage;

    const onSuccess = (res) => {
      const rawData = res?.data || [];
      rawData.forEach((item, index) => {
        item["slno"] = pp === "all" ? index + 1 : (pg - 1) * Number(pp) + index + 1;
      });
      setdata(rawData);
      setTotalPages(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
      setIsActive(false);
    };
    const onError = () => { setdata([]); setIsActive(false); };

    if (id === "registry") {
      get_candidates_list(adminType, pg, pp === "all" ? 99999 : pp, { status }).then(onSuccess).catch(onError);
    } else if (id === "employed") {
      admin_candidates_employed_list(adminType, pg, pp === "all" ? 99999 : pp).then(onSuccess).catch(onError);
    } else if (id === "inactive") {
      admin_candidates_inactive_list(adminType, pg, pp === "all" ? 99999 : pp).then(onSuccess).catch(onError);
    } else if (id === "optedout") {
      admin_candidates_deactivated_list(adminType, pg, pp === "all" ? 99999 : pp).then(onSuccess).catch(onError);
    } else {
      get_candidates_list(adminType, pg, pp === "all" ? 99999 : pp, { status }).then(onSuccess).catch(onError);
    }
  };

  // Re-fetch whenever page, perPage, status, or tab (id) changes
  useEffect(() => {
    handleListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, status, id]);

  // Reset to page 1 when tab changes
  useEffect(() => {
    setPage(1);
    setStatus("");
  }, [id]);

  const handleChangeStatus = (e) => {
    setStatus(e.target.value);
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  };

  const handleView = (data) => {
    props.history.push(`/candidates-view/${data.id}/${id ?? "registry"}`);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_cand_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
        handleListData();
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleListData();
  };

  const handleCancelDelete = () => setOpenAction(false);

  const handleBulkEmail = () => {
    props.history.push(`/bulk-email-job-seekers/${id ?? "registry"}`);
  };

  const handleInterest = (input) => {
    try {
      return JSON.parse(input).map((i) => i.replace("/", " ")).join(", ");
    } catch { return ""; }
  };

  async function fetchExportData() {
    return data.map((item, i) => ({
      "Sl no": i + 1,
      Name: item?.name,
      Phone: item?.contact,
      Email: item?.email,
      "Alternate Phone": item?.alt_contact,
      "Alternate Email": item?.alt_email,
      "Highest Qualification - Type": item?.education?.[0]?.edu_type_parent,
      "Highest Qualification": item?.education?.[0]?.edu_type_sub_one && item?.education?.[0]?.edu_type_sub_one !== "Others"
        ? item?.education?.[0]?.edu_type_sub_one
        : item?.education?.[0]?.edu_type_others_text ?? "",
      "Highest Qualification - Stream": item?.education?.[0]?.edu_type_sub_two
        ? item?.education?.[0]?.edu_type_sub_two !== "Others"
          ? item?.education?.[0]?.edu_type_sub_two
          : item?.education?.[0]?.edu_type_others_text
        : "",
      "Highest Qualification - Percentage": item?.education?.[0]?.percentage,
      "Highest Qualification - Graduated in": item?.education?.[0]?.year,
      Experienced: item?.employment?.length !== 0 ? "Yes" : "No",
      Address: item?.address,
      "Registration Date": moment(item?.created_at).format("DD/MM/yyyy"),
      "Area of interest": item?.interest_type,
      Preferences: item?.interest ? handleInterest(item?.interest) : "",
      Status: STATUS_OPTIONS.find(s => String(s.value) === String(item.status))?.label || "",
    }));
  }

  async function fetchExportBasicData() {
    return data.map((item, i) => ({
      "Sl no": i + 1,
      Name: item?.name,
      Phone: item?.contact,
      Email: item?.email,
      "Alternate Phone": item?.alt_contact,
      "Alternate Email": item?.alt_email,
      Status: item.status === 0 ? "Pending"
        : item.status === 1 ? "Submitted"
        : item.status === 2 ? "Approved"
        : item.status === 3 ? "Joined Successfully"
        : item.status === 4 ? "Payment Done"
        : item.status === 5 ? "Rejected" : "",
    }));
  }

  const downloadExcel = async () => {
    setIsDownloading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 300));
      const exportData = id === "employed" ? await fetchExportBasicData() : await fetchExportData();
      if (!exportData.length) {
        setSnackMessage("No data to export");
        setIsSnackError(true);
        setSnackOpen(true);
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Job Seekers");
      const fileName = (id === "registry" ? "Job_Seeker_Registry"
        : id === "employed" ? "Job_Seekers_Employed"
        : id === "inactive" ? "Inactive_Job_Seekers"
        : id === "optedout" ? "Opted_Out_Job_Seekers"
        : "Job_Seeker_Data") + ".xlsx";
      XLSX.writeFile(workbook, fileName);
    } finally {
      setIsDownloading(false);
    }
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

    if (start > 1) {
      pages.push(<button key={1} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(1)}>1</button>);
      if (start > 2) pages.push(<span key="s-dots" className="px-1 text-primary">...</span>);
    }
    for (let i = start; i <= end; i++) {
      pages.push(
        <button key={i} className={`btn ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`} style={{ fontSize: "13px" }} onClick={() => setPage(i)}>{i}</button>
      );
    }
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="e-dots" className="px-1 text-primary">...</span>);
      pages.push(<button key={totalPages} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(totalPages)}>{totalPages}</button>);
    }
    return pages;
  };

  const pageTitle = id === "registry" ? "Job Seeker Registry"
    : id === "employed" ? "Directory of Job Seekers Employed through KSPACE"
    : id === "inactive" ? "Directory of Inactive Job Seeker Registrations"
    : id === "optedout" ? "Directory of Job Seekers Opted-Out"
    : "Job Seeker Data";

  const showStatusFilter = id === "registry" || !id;

  return (
    <>
      <div className="container-fluid mt-4">
        <Loader open={isActive} />
        <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />

        <div className="card shadow-sm">
          {/* ── Card Header ── */}
          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0"><b>{pageTitle}</b></h5>
            <div className="d-flex gap-2">
              {totalRecords > 0 && id === "registry" && adminType !== 2 && (
                <button className="btn btn-primary btn-sm search-style border-0 text-white rounded" onClick={handleBulkEmail}>
                  Bulk Email
                </button>
              )}
              <button className="btn btn-primary btn-sm search-style border-0 text-white rounded" onClick={downloadExcel} disabled={isDownloading}>
                {isDownloading ? (
                  <>
                    <svg className="me-1" style={{ width: "1rem", height: "1rem", animation: "spin 1s linear infinite" }} viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeOpacity="0.25" />
                      <path d="M12 2C6.48 2 2 6.48 2 12" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                    </svg>
                    Downloading...
                  </>
                ) : "Download Excel"}
              </button>
              {showStatusFilter && (
                <button
                  className={`filter-icon-btn ${showFilters ? "active" : ""}`}
                  onClick={() => setShowFilters(!showFilters)}
                  title="Toggle Filters"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                  </svg>
                </button>
              )}
            </div>
          </div>

          <div className="card-body pt-0">
            {/* ── Collapsible Filter Panel ── */}
            {showStatusFilter && (
              <div className={`filter-container ${showFilters ? "show" : ""}`}>
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <label className="form-label small">Status</label>
                    <select className="form-control filter-select" value={status} onChange={handleChangeStatus}>
                      {STATUS_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 d-flex gap-2 align-items-end">
                    <button
                      className="filter-action-btn"
                      title="Reset Filters"
                      onClick={() => { setStatus(""); setPage(1); }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                        <path d="M3 3v5h5"></path>
                      </svg>
                    </button>
                    <button className="filter-action-btn close-btn" title="Close Filters" onClick={() => setShowFilters(false)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ── Pagination Info + Controls ── */}
            <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded border" style={{ fontSize: "14px" }}>
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted fw-semibold">
                  Showing <span className="text-dark fw-bold">{data.length}</span> of <span className="text-dark fw-bold">{totalRecords}</span> records
                </span>
                <span className="badge bg-primary" style={{ fontSize: "13px", padding: "6px 12px" }}>
                  Page {page} of {totalPages}
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label className="text-muted fw-semibold mb-0" style={{ fontSize: "13px" }}>Rows per page:</label>
                  <select className="form-select form-select-sm" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "13px", height: "36px", width: "80px" }}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="all">All</option>
                  </select>
                </div>
                <div className="btn-group">
                  <button className="btn btn-outline-primary" disabled={page === 1} onClick={() => setPage((p) => p - 1)} style={{ fontSize: "13px" }}>Prev</button>
                  {renderPagination()}
                  <button className="btn btn-outline-primary" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)} style={{ fontSize: "13px" }}>Next</button>
                </div>
              </div>
            </div>

            {/* ── Data Table ── */}
            <CustomTable
              {...props}
              paging={false}
              columns={[
                { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
                { title: "Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Phone Number", field: "contact" },
                { title: "Updated at", field: "updated_at", type: "fullDateTime" },
                {
                  title: "Status",
                  field: "status",
                  render: (row) => {
                    const statusInfo = getStatusInfo(row.status, id);
                    return (
                      <span className={`status-badge ${statusInfo.class}`}>
                        <span className="status-icon">{statusInfo.icon}</span>
                        <span className="status-label">{statusInfo.label}</span>
                      </span>
                    );
                  },
                },
                {
                  title: "Action",
                  render: (row) => (
                    <div className="d-flex gap-1">
                      <button className="btn btn-sm btn-outline-primary action-btn" onClick={() => handleView(row)} title="View">
                        <FiEye size={16} />
                      </button>
                      {adminType === 2 && (
                        <button className="btn btn-sm btn-outline-danger action-btn" onClick={() => handleDelete(row)} title="Delete">
                          <FiTrash2 size={16} />
                        </button>
                      )}
                    </div>
                  ),
                },
              ]}
              data={data}
              options={{ search: false, selection: false, exportButton: false }}
            />
          </div>
        </div>

        {openAction && (
          <ConfirmDialog
            open={openAction}
            title="Delete Job Seeker?"
            data={activeData}
            message="Are you sure to delete this Job Seeker?"
            secondary_action="Cancel"
            primary_action="Delete"
            handleClose={handleCancelDelete}
            handleConfirm={handleDeleteConfirm}
          />
        )}
      </div>
    </>
  );
}
